module.exports = __webpack_public_path__ + "img/sort-za-grey.f351147c.svg";